import DefaultValidation from '@/services/validations/DefaultValidation';
import { isNull } from "@/functions/Util";

export default class PortalDoClienteUserManage extends DefaultValidation{

    validate(model, idToEdit, refs) {
        let validated = true;
        
        if (isNull(model.idempresa)) {
            refs.empresaSelect.focusedOut = true;
            validated = false;
        }
        if (isNull(model.idcliente)) {
            refs.clienteSelect.focusedOut = true;
            validated = false;
        }
        if (isNull(model.nome)) {
            refs.nomeInput.focusedOut = true;
            validated = false;
        }
        if (isNull(model.email)) {
            refs.emailInput.focusedOut = true;
            validated = false;
        }
        if (isNull(model.chave) && idToEdit == null) {
            refs.chaveInput.focusedOut = true;
            validated = false;
        }
        return validated;
    }
}